<template>
  <div>
    <h-m-dropdown v-if="!item.route" :title="item.name" :style="formatDeathIndent">
      <template v-if="!item.default" #buttons-left>
        <h-b-action-rounded
          icon="bx bx-edit-alt"
          class="mr-1"
          size="sm"
          @click.native="$emit('clickEditFolder', item.id)"
        ></h-b-action-rounded>
        <h-b-action-rounded
          icon="bx bx-trash-alt"
          size="sm"
          @click.native="$emit('clickDeleteFolder', item.id)"
        ></h-b-action-rounded>
      </template>
      <template #buttons-right>
        <i v-if="!item.default" class="mdi mdi-folder-plus-outline mr-1" @click="$emit('clickAddFolder', item.id)"></i>
        <i
          v-if="item.label !== 'fav' && item.label !== 'my' && item.label !== 'shared'"
          class="mdi mdi-plus"
          @click="$emit('clickAddFile', item.id)"
        ></i>
      </template>
      <template #content>
        <h-fe-tree-menu
          v-for="folder in folders"
          :key="folder.id"
          :folders="folder.folders"
          :item="folder"
          :depth="depth + 1"
          :actual-file-id="actualFileId"
          @clickFav="clickFav"
          @clickDeleteFolder="clickDeleteFolder"
          @clickAddFolder="clickAddFolder"
          @clickEditFolder="clickEditFolder"
          @clickSelectFile="clickSelectFile"
          @clickAddFile="clickAddFile"
        >
        </h-fe-tree-menu>
        <h-m-dropdown-item
          v-for="file in item.files"
          :key="file.id"
          :icon="file.type === 'note' ? 'mdi mdi-clipboard-text-outline' : 'mdi mdi-file-document-outline'"
          :title="file.name"
          :description="formatDescription(file)"
          :is-fav="file.favorite_users.indexOf(userMe) >= 0"
          :is-active="file.id === actualFileId"
          @clickFav="$emit('clickFav', file.id)"
          @click="$emit('clickSelectFile', file.id)"
        >
        </h-m-dropdown-item>
      </template>
    </h-m-dropdown>
    <div v-else>
      <h-fe-tree-menu
        v-for="(folder, index) in folders"
        :key="index"
        :folders="folder.folders"
        :item="folder"
        :depth="depth"
        :actual-file-id="actualFileId"
        @clickFav="clickFav"
        @clickDeleteFolder="clickDeleteFolder"
        @clickAddFolder="clickAddFolder"
        @clickEditFolder="clickEditFolder"
        @clickSelectFile="clickSelectFile"
        @clickAddFile="clickAddFile"
      >
      </h-fe-tree-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tree-menu',
  props: {
    folders: {
      type: Array,
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
    depth: {
      type: Number,
      default: 0,
    },
    actualFileId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      userMe: JSON.parse(localStorage.getItem('user_object')).uuid,
    }
  },

  computed: {
    formatDeathIndent() {
      return `margin-left: ${this.depth * 10}px; width: calc(100% - ${this.depth * 10}px)`
    },
  },

  methods: {
    clickFav(fileId) {
      this.$emit('clickFav', fileId)
    },

    clickDeleteFolder(folderId) {
      this.$emit('clickDeleteFolder', folderId)
    },

    clickEditFolder(folderId) {
      this.$emit('clickEditFolder', folderId)
    },

    clickAddFolder(folderId) {
      this.$emit('clickAddFolder', folderId)
    },

    clickSelectFile(fileId) {
      this.$emit('clickSelectFile', fileId)
    },

    clickAddFile(folderId) {
      this.$emit('clickAddFile', folderId)
    },

    formatDescription(file) {
      if (file.type === 'note' && file.text) {
        const parser = new DOMParser()
        return parser.parseFromString(file.text, 'text/html').body.children[0].innerText
      }
      return ''
    },
  },
}
</script>

<style scoped></style>
